module.exports = __webpack_public_path__ + "static/media/pino_visby.05d9ad59.jpg";